<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  font-family: Arial, sans-serif;
}

/* 为router-link-active添加样式 */
.nav-item.router-link-active {
  color: #3498db;
  font-weight: bold;
}

/* 固定头部样式 */
.header-fixed {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

/* 当头部固定时，为页面内容添加顶部间距 */
.header-fixed + .main-content,
.header-fixed ~ .main-content {
  padding-top: 80px; /* 根据头部高度调整 */
}

/* 确保固定头部在所有页面都正常工作 */
.page-container {
  position: relative;
  min-height: 100vh;
}
</style>